import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const shopCardListDefaultVariants = {}
const shopCardListCompoundVariants = []

const shopCardListSlotNames = [
  [
    "root",
    "shop-card-list__root"
  ],
  [
    "row",
    "shop-card-list__row"
  ],
  [
    "columnLeft",
    "shop-card-list__columnLeft"
  ],
  [
    "columnRight",
    "shop-card-list__columnRight"
  ],
  [
    "summary",
    "shop-card-list__summary"
  ],
  [
    "summaryValue",
    "shop-card-list__summaryValue"
  ],
  [
    "summaryName",
    "shop-card-list__summaryName"
  ]
]
const shopCardListSlotFns = /* @__PURE__ */ shopCardListSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, shopCardListDefaultVariants, getSlotCompoundVariant(shopCardListCompoundVariants, slotName))])

const shopCardListFn = memo((props = {}) => {
  return Object.fromEntries(shopCardListSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const shopCardListVariantKeys = []
const getVariantProps = (variants) => ({ ...shopCardListDefaultVariants, ...compact(variants) })

export const shopCardList = /* @__PURE__ */ Object.assign(shopCardListFn, {
  __recipe__: false,
  __name__: 'shopCardList',
  raw: (props) => props,
  variantKeys: shopCardListVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, shopCardListVariantKeys)
  },
  getVariantProps
})